import { render, staticRenderFns } from "./ExpenseDialog.vue?vue&type=template&id=2af11a8e&"
import script from "./ExpenseDialog.vue?vue&type=script&lang=js&"
export * from "./ExpenseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports